import $ from 'jquery';

$( '.c-accordion__toggle' ).on('click', function(e) {
	e.preventDefault();

	var $this = $(this);

	if ($this.hasClass( 'is-expanded' )) {
		$this.removeClass( 'is-expanded' );
		$this.next().slideUp(350);
	} else {
		$this.parents( '.c-accordion' ).find( '.c-accordion__toggle' ).removeClass( 'is-expanded' );
		$this.parents( '.c-accordion' ).find( '.c-accordion__panel' ).slideUp(350);
		$this.toggleClass( 'is-expanded' );
		$this.next().slideToggle(350);
	}
} );
